import axios from "axios";
import React, { useEffect, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BASE_URL as api } from "../services";
import { LoadingSpinner } from "../Components/loading";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import app from "../Components/firebase";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
export const Create = () => {
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [uname, setuname] = useState("");
  const [email, setEmail] = useState(sessionStorage.token);
  const [dob, setDob] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [instagramId, setInstagramId] = useState("");
  const [facebookId, setFacebookId] = useState("");
  const [githubId, setGithubId] = useState("");
  const [linkedinLink, setLinkedinLink] = useState("");
  const [projects, setProjects] = useState([
    { title: "", description: "", link: "" },
  ]);
  const [certificates, setCertificates] = useState([
    { title: "", description: "", link: "" },
  ]);
  const [skills, setSkills] = useState([""]);
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [isUsernameTaken, setIsUsernameTaken] = useState(false);
  const [isfilled, setIsfilled] = useState(false);
  const [count, setCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [photo, setPhoto] = useState(undefined);
  const [resume, setResume] = useState(undefined);
  const [photoPerc, setPhotoPerc] = useState(0);
  const [resumePerc, setResumePerc] = useState(0);
  const [inputs, setInputs] = useState({
    photoUrl: null,
    resumeUrl: null,
  });
  const handlePhotoUpload = () => {
    document.getElementById("pUpload").disabled = true;
    photo && uploadFile(photo, "photoUrl");
  };
  const handleResumeUpload = () => {
    document.getElementById("rUpload").disabled = true;
    resume && uploadFile(resume, "resumeUrl");
  };
  const uploadFile = (file, fileType) => {
    const storage = getStorage(app);
    const folder = fileType === "photoUrl" ? "photos/" : "resumes/";
    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, folder + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        fileType === "photoUrl"
          ? setPhotoPerc(Math.round(progress))
          : setResumePerc(Math.round(progress));
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            break;
          case "storage/canceled":
            // User canceled the upload
            break;

          // ...

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            break;
          default:
            break;
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // console.log("File available at", downloadURL);
          // setInputs((prev) => [...prev, { [fileType]: downloadURL }]);
          setInputs((prev) => ({ ...prev, [fileType]: downloadURL }));
        });
      }
    );
  };
  const handleResumeChange = (e) => {
    const file = e.target.files[0];

    // Check if the file size is greater than 2 MB
    if (file && file.size > 2 * 1024 * 1024) {
      toast.error("File size exceeds the maximum limit of 2 MB.");
      // Optionally clear the input or handle the error as needed
    } else {
      setResume(file);
      document.getElementById("rUpload").disabled = false;
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];

    // Check if the file size is greater than 2 MB
    if (file && file.size > 2 * 1024 * 1024) {
      toast.error("File size exceeds the maximum limit of 2 MB.");
      // Optionally clear the input or handle the error as needed
    } else {
      setPhoto(file);
      document.getElementById("pUpload").disabled = false;
    }
  };

  const usernameRegex = /^[a-zA-Z0-9_]+$/;
  const handleProjectChange = (e, index, field) => {
    const updatedProjects = [...projects];
    updatedProjects[index][field] = e.target.value;
    setProjects(updatedProjects);
  };

  const addProject = () => {
    setProjects([...projects, { title: "", description: "", link: "" }]);
  };
  const addSkill = () => {
    setSkills([...skills, ""]);
  };
  const deleteSkill = () => {
    const updatedSkills = [...skills];
    updatedSkills.splice(skills.length - 1, 1);
    setSkills(updatedSkills);
  };
  const deleteProject = () => {
    const updatedProjects = [...projects];
    updatedProjects.splice(projects.length - 1, 1);
    setProjects(updatedProjects);
  };
  const handleCertificateChange = (e, index, field) => {
    const updatedCertificates = [...certificates];
    updatedCertificates[index][field] = e.target.value;
    setCertificates(updatedCertificates);
  };

  const addCertificate = () => {
    setCertificates([
      ...certificates,
      { title: "", description: "", link: "" },
    ]);
  };
  const deleteCertificate = () => {
    const updatedCertificates = [...certificates];
    updatedCertificates.splice(certificates.length - 1, 1);
    setCertificates(updatedCertificates);
  };

  const handleSkillChange = (e, index) => {
    const updatedSkills = [...skills];
    updatedSkills[index] = e.target.value;
    setSkills(updatedSkills);
  };

  const handleClick = async () => {
    setIsLoading(true);
    setCount((prevCount) => prevCount + 1);
    if (count % 2 === 0 && count < 3) {
      toast.info(" please verify above details and create ...");
    }
    try {
      const res = await axios.post(api+"/portfolio/register", {
        uname,
        name,
        email,
        dob,
        phoneNumber,
        instagramId,
        facebookId,
        githubId,
        linkedinLink,
        projects,
        skills,
        certificates,
        address,
        pincode,
        inputs,
      });
      console.log(res);
      if (res) {
        if (res.data === "you already have portifolio in this domain") {
          toast.info("you already have portifolio in this domain");
        } else {
          toast.success("user successfully registered");
          sessionStorage.clear();
          window.location.href = "/?page=true";
          toast.info("Please Login in again");
        }
      } else {
        toast.error("Try again");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
      nav("/",{replace:true});
    }
  };
  const checkUsernameAvailability = async (uname) => {
    const route = ["create", "update", "forgot", "signup"];
    if (uname && uname.length > 3) {
      try {
        const response = await axios.post(
          `${api}/port/${uname}`
        );

        // Ensure that response.data is not null and has the expected structure
        if (usernameRegex.test(uname) && !route.includes(uname)) {
          setIsfilled(true);
        } else {
          toast.error("username allowed only letters, numbers and underscores");
          setIsfilled(false);
        }
        if (!response.data) {
          setIsUsernameTaken(false);
        } else {
          // Handle unexpected response structure
          setIsUsernameTaken(true);
        }
      } catch (error) {
        console.error("Error checking username availability:", error);
        // Handle errors here
      } finally {
      }
    }
  };
  useEffect(() => {
    if (!sessionStorage.token) {
      window.location.href = "/";
    }
    const delayTimer = setTimeout(() => {
      checkUsernameAvailability(uname);
    }, 2000); // Adjust the delay time as needed

    return () => clearTimeout(delayTimer); // Cleanup timer on component unmount or re-render
  });

  return (
    <>
      < LoadingSpinner state={isLoading} />
      <div className=" " style={{ backgroundColor: "#293845" }}>
        <div className="register-container row justify-content-center">
          <div className="col-md-8">
            <div className="card">
              <div className="card-header">
                <h2 className="text-center">Create your Portfolio</h2>
              </div>
              <div className="card-body">
                <form>
                  <div className="register-form">
                    <div
                      className="form-group p-2"
                      style={{
                        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        borderRadius: "6px",
                      }}
                    >
                      <label htmlFor="name">User Name</label>
                      <input
                        required
                        type="text"
                        id="uname"
                        className="form-control"
                        placeholder="create unique username....."
                        name="uname"
                        value={uname}
                        onChange={(e) => {
                          const lowercase = e.target.value.toLowerCase();
                          setuname(lowercase);
                        }}
                      />
                      {isUsernameTaken && (
                        <div style={{ color: "red" }}>
                          {uname} already taken
                        </div>
                      )}
                      {!isUsernameTaken &&
                        isfilled &&
                        usernameRegex.test(uname) && (
                          <div style={{ color: "green" }}>
                            {uname} is available
                          </div>
                        )}

                      <small>Username without spaces </small>
                    </div>

                    <div
                      className="row"
                      style={{
                        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        borderRadius: "6px",
                      }}
                    >
                      <div
                        className="col-md-6 mt-2 p-2"
                        style={{
                          boxShadow:
                            " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                          borderRadius: "6px",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="name">Name</label>
                          <input
                            required
                            type="text"
                            id="name"
                            className="form-control"
                            placeholder="Full Name"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="email">Email</label>
                          <input
                            required
                            type="email"
                            id="email"
                            className="form-control"
                            placeholder="E-mail"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="dob">Date of Birth</label>
                          <input
                            type="date"
                            id="dob"
                            className="form-control"
                            placeholder="Date of Birth"
                            name="dob"
                            value={dob}
                            onChange={(e) => setDob(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="phoneNumber">Phone Number</label>
                          <input
                            type="text"
                            id="phoneNumber"
                            className="form-control"
                            placeholder="Phone Number"
                            name="phoneNumber"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="instagramId">Instagram ID</label>
                          <input
                            type="text"
                            id="instagramId"
                            className="form-control"
                            placeholder="Instagram ID"
                            name="instagramId"
                            value={instagramId}
                            onChange={(e) => setInstagramId(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="photoupload">Photo</label>
                          <div className="input-group ">
                            <input
                              type="file"
                              accept="image/*"
                              id="photoupload"
                              className="form-control"
                              name="photoupload"
                              onChange={(e) => handlePhotoChange(e)}
                            />
                            <button
                              type="button"
                              className="uploadfiles bg-primary text-white"
                              id="pUpload"
                              onClick={handlePhotoUpload}
                              
                            >
                              Upload
                            </button>
                          </div>
                          {photoPerc > 0 && (
                            <div style={{ color: "black" }}>
                              Uploading:{" "}
                              {photoPerc === 100
                                ? "completed" 
                                : photoPerc + "%"}
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className="col-md-6 mt-2 p-2"
                        style={{
                          borderRadius: "6px",
                        }}
                      >
                        <div className="form-group">
                          <label htmlFor="linkedinlink">Linkedin link</label>
                          <input
                            type="text"
                            id="linkedinlink"
                            className="form-control"
                            placeholder="Linkedin Link"
                            name="Linkedin_link"
                            value={linkedinLink}
                            onChange={(e) => setLinkedinLink(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="FacebookId">Facebook ID</label>
                          <input
                            type="text"
                            id="FacebookId"
                            className="form-control"
                            placeholder="Facebook ID"
                            name="instagramId"
                            value={facebookId}
                            onChange={(e) => setFacebookId(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="githubId">Github ID</label>
                          <input
                            type="text"
                            id="githubId"
                            className="form-control"
                            placeholder="Github ID"
                            name="githubId"
                            value={githubId}
                            onChange={(e) => setGithubId(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="address">City</label>
                          <input
                            type="text"
                            id="address"
                            placeholder="Nearest City"
                            className="form-control"
                            name="address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="pinecode">Pincode</label>
                          <input
                            type="text"
                            id="pinecode"
                            placeholder="Pin code"
                            className="form-control"
                            name="pinecode"
                            value={pincode}
                            onChange={(e) => setPincode(e.target.value)}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="resumeupload">Resume</label>
                          <div className="input-group">
                            <input
                              type="file"
                              accept=".pdf"
                              id="resumeupload"
                              className="form-control"
                              name="resumeupload"
                              onChange={(e) => handleResumeChange(e)}
                            />
                            <button
                              type="button"
                              className="uploadfiles bg-primary text-white"
                              onClick={handleResumeUpload}
                              id="rUpload"
                             
                            >
                              Upload
                            </button>
                          </div>
                          {resumePerc > 0 && (
                            <div style={{ color: "black" }}>
                              Uploading:{" "}
                              {resumePerc === 100
                                ? "completed"
                                : resumePerc + "%"}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Projects */}
                    <div
                      className="form-group"
                      style={{
                        marginBottom: "4px",
                        marginTop: "5px",
                        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        borderRadius: "6px",
                      }}
                    >
                      <label>
                        {" "}
                        <b>Projects:</b>
                      </label>
                      {projects.map((project, index) => (
                        <div>
                          {index + 1 + "."}
                          <div
                            key={index}
                            style={{
                              border: "1px solid gray",
                              marginBottom: "4px",

                              boxShadow:
                                " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              borderRadius: "6px",
                            }}
                          >
                            <input
                              type="text"
                              placeholder="Project Title"
                              value={project.title}
                              className="form-control"
                              onChange={(e) =>
                                handleProjectChange(e, index, "title")
                              }
                            />
                            <input
                              type="text"
                              placeholder="Project Description"
                              className="form-control"
                              value={project.description}
                              onChange={(e) =>
                                handleProjectChange(e, index, "description")
                              }
                            />
                            <input
                              type="text"
                              placeholder="Project Link"
                              className="form-control"
                              value={project.link}
                              onChange={(e) =>
                                handleProjectChange(e, index, "link")
                              }
                            />
                            <small className="p-2 text-danger">
                              Ex:https://yourwebsite.com/
                            </small>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addProject}
                      >
                        <i class="fa-solid fa-plus"></i> Project
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={deleteProject}
                      >
                        <i class="fa-solid fa-minus"></i> Project
                      </button>
                    </div>

                    {/* Certificates */}
                    <div
                      className="form-group"
                      style={{
                        marginBottom: "4px",
                        marginTop: "5px",
                        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        borderRadius: "6px",
                      }}
                    >
                      <label>Certificates:</label>
                      {certificates.map((certificate, index) => (
                        <div>
                          {index + 1 + "."}
                          <div
                            key={index}
                            style={{
                              border: "1px solid black",
                              marginBottom: "4px",

                              boxShadow:
                                " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                              borderRadius: "6px",
                            }}
                          >
                            <input
                              type="text"
                              placeholder="Certificate Title"
                              className="form-control"
                              value={certificate.title}
                              onChange={(e) =>
                                handleCertificateChange(e, index, "title")
                              }
                            />
                            <input
                              type="text"
                              placeholder="Certificate Description"
                              value={certificate.description}
                              className="form-control"
                              onChange={(e) =>
                                handleCertificateChange(e, index, "description")
                              }
                            />
                            <input
                              type="text"
                              placeholder="Certificate Link"
                              value={certificate.link}
                              className="form-control"
                              onChange={(e) =>
                                handleCertificateChange(e, index, "link")
                              }
                            />
                            <small className="p-2 text-danger">
                              Ex:https://docs.google.com/docs/certificate/
                            </small>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addCertificate}
                      >
                        <i class="fa-solid fa-plus"></i> Certificate
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={deleteCertificate}
                      >
                        <i class="fa-solid fa-minus"></i> Certificate
                      </button>
                    </div>

                    {/* Skills with add button for more skills */}
                    <div
                      className="form-group"
                      style={{
                        marginBottom: "4px",
                        marginTop: "5px",
                        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        borderRadius: "6px",
                      }}
                    >
                      <label>Skills:</label>
                      {skills.map((skill, index) => (
                        <div>
                          <div
                            key={index}
                            style={{
                              border: "1px solid black ",
                              boxShadow:
                                " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
                              borderRadius: "6px",
                              marginBottom: "4px",
                            }}
                          >
                            <input
                              type="text"
                              placeholder="Skill"
                              className="form-control"
                              value={skill}
                              onChange={(e) => handleSkillChange(e, index)}
                            />
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addSkill}
                      >
                        <i class="fa-solid fa-plus"></i> Skill
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={deleteSkill}
                      >
                        <i class="fa-solid fa-minus"></i> Skill
                      </button>
                    </div>

                    {/* ... Repeat the above structure for other new fields ... */}
                    <div
                      className="form-group "
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                      title={"please fill above details before registering..."}
                    >
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleClick}
                        disabled={!isfilled}
                        data-bs-toggle=""
                        data-bs-target="#exampleModal"
                        id="register"
                      >
                        <b>Register</b>
                      </button>
                      {/* <Link className="login-link" onClick={login}>
                  <b>Login</b>
                </Link> */}
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div />
          </div>
        </div>
      </div>
    </>
  );
};
